/**
 * Why a name was refused before it was sent: the API's own name rule, which every form
 * that takes a name checks first (lib/names.ts). The same lines serve keys, API tokens,
 * containers and firewalls, so none of them says what a name is for.
 */
export const names = {
  empty: 'A name is required.',
  blank: 'A name of only whitespace is rejected. Give it something readable.',
  tooLong: (max: number) => `A name is at most ${max} characters.`,
  controlChar: 'A name cannot contain control characters.',
} as const;
